import { aroApiSlice } from './apiSlice';
import { getBaseURL } from '../../../utilities/config';

// To Do: use baseURL and remove full url from query
export const acquisitionsApiSlice = aroApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAcquisitions: builder.query({
            query: () => `${getBaseURL()}/acquisitions`,
            providesTags: ['Acquisitions'],
            transformResponse: (response) => {
                const transformedResponse = { ...response };
                transformedResponse.salesActualDates ??= [];
                return { ...transformedResponse };
            },
        }),
        putAcquisitions: builder.mutation({
            query: (updates) => {
                return {
                    url: `${getBaseURL()}/acquisitions`,
                    method: 'PUT',
                    body: {
                        ...updates,
                    },
                };
            },
            invalidatesTags: ['Acquisitions'],
        }),
    }),
});

export const { useGetAcquisitionsQuery, usePutAcquisitionsMutation } =
  acquisitionsApiSlice;
